export const isProjectEditable = (project, userId) => {
  return project.ownerId === userId || project.userId === userId || project.participantsIds?.includes(userId);
};

export const canProjectBeCirculated = (project) => {
  return !project.sharingType || project.sharingType === "circulate";
};
